<app-popin [popinTitle]="data.report.attributes.name"
           subtitle="Settings"
           subtitleIcon="settings">
  <ng-container content>
    <app-datepicker appearance="outline"
                    [form]="form"
                    [control]="periodCtrl"
                    [value]="data.report.attributes.parameters.period"
                    [disableComparison]="data.disableComparison"
                    [labelAnimation]="false"
                    [centerPosition]="true"></app-datepicker>
  </ng-container>
  <ng-container actions>
    <app-button buttonType="mat-button"
                (onClick)="onClose()">Close</app-button>
    <app-button icon="done"
                buttonType="mat-raised-button"
                (onClick)="onSubmit()">Submit</app-button>
  </ng-container>
</app-popin>
